<template>
  <section class="five-card-hands-section panel panel-default">
    <five-card-hands-section-header
      v-if="!hideHeader"
      v-bind:hitPercentageBeingComputed="playerState.hitPercentageBeingComputed"
      v-bind:hitPercentageUpToDate="hitPercentageUpToDate"
      v-bind:hitPercentage="playerState.hitPercentage"
      v-bind:stateName="playerState.name"
      v-bind:authorized="authorized"
      v-on:clearAllChecks="$emit('clearAllChecks')"
      v-on:selectAllChecks="$emit('selectAllChecks')"
      v-on:setChecksToDefault="$emit('setChecksToDefault', $event)"
      v-on:setChecksBasedOnUserDefinedFilter="$emit('setChecksBasedOnUserDefinedFilter', $event)"
    />
    <section class="panel-body">
      <slot v-if="insightsVisible" name="insights"></slot>
      <percentages-or-combos
        v-if="showPercentagesOrCombos"
        v-bind:percentagesOrCombos="percentagesOrCombos"
        v-bind:numberOfSpecificHandsInRange="playerState.generalHands.numberOfSpecificHandsInRange"
        v-bind:numberOfPossibleSpecificHands="playerState.generalHands.numberOfPossibleSpecificHands"
        v-on:toggle="percentagesOrCombos = $event"
      />
      <slot name="alerts"></slot>
      <div class="row">
        <div class="col-sm-4">
          <span class="level-1">Made hands:</span>
          <five-card-hands-for-category
            v-bind:type="'made-hands'"
            v-bind:playerState="playerState"
            v-bind:percentagesOrCombos="percentagesOrCombos"
            v-bind:hideRightContainer="hideRightContainer"
            v-bind:shortDeck="shortDeck"
            v-bind:authorized="authorized"
            v-on:setCheckedValueOfFiveCardHand="setCheckedValueOfFiveCardHand($event)"
            v-on:applyExactWeightToFiveCardHand="$emit('applyExactWeightToFiveCardHand', $event)"
            v-on:toggleCollapsedValueOfFiveCardHandParent="$emit('toggleCollapsedValueOfFiveCardHandParent', $event)"
            v-on:updateWeightOfFiveCardHand="$emit('updateWeightOfFiveCardHand', $event)"
            v-on:fiveCardHandMouseover="$emit('fiveCardHandMouseover', $event)"
            v-on:fiveCardHandMouseleave="$emit('fiveCardHandMouseleave')"
          />
        </div>
        <div v-if="playerState.fiveCardHands.visibleDraws.length > 0" class="col-sm-4">
          <span class="level-1">Draws:</span>
          <five-card-hands-for-category
            v-bind:type="'draws'"
            v-bind:playerState="playerState"
            v-bind:percentagesOrCombos="percentagesOrCombos"
            v-bind:hideRightContainer="hideRightContainer"
            v-bind:shortDeck="shortDeck"
            v-bind:authorized="authorized"
            v-on:setCheckedValueOfFiveCardHand="setCheckedValueOfFiveCardHand($event)"
            v-on:applyExactWeightToFiveCardHand="$emit('applyExactWeightToFiveCardHand', $event)"
            v-on:toggleCollapsedValueOfFiveCardHandParent="$emit('toggleCollapsedValueOfFiveCardHandParent', $event)"
            v-on:updateWeightOfFiveCardHand="$emit('updateWeightOfFiveCardHand', $event)"
            v-on:fiveCardHandMouseover="$emit('fiveCardHandMouseover', $event)"
            v-on:fiveCardHandMouseleave="$emit('fiveCardHandMouseleave')"
          />
        </div>
        <div v-if="playerState.fiveCardHands.visibleCombos.length > 0" class="col-sm-4">
          <span class="level-1">Combos:</span>
          <five-card-hands-for-category
            v-bind:type="'combos'"
            v-bind:playerState="playerState"
            v-bind:percentagesOrCombos="percentagesOrCombos"
            v-bind:hideRightContainer="hideRightContainer"
            v-bind:shortDeck="shortDeck"
            v-bind:authorized="authorized"
            v-on:setCheckedValueOfFiveCardHand="setCheckedValueOfFiveCardHand($event)"
            v-on:applyExactWeightToFiveCardHand="$emit('applyExactWeightToFiveCardHand', $event)"
            v-on:toggleCollapsedValueOfFiveCardHandParent="$emit('toggleCollapsedValueOfFiveCardHandParent', $event)"
            v-on:updateWeightOfFiveCardHand="$emit('updateWeightOfFiveCardHand', $event)"
            v-on:fiveCardHandMouseover="$emit('fiveCardHandMouseover', $event)"
            v-on:fiveCardHandMouseleave="$emit('fiveCardHandMouseleave')"
          />
        </div>
      </div>
    </section>
    <slot name="simulate-button"></slot>
  </section>
</template>

<script>
import FiveCardHandsSectionHeader from '@/components/five-card-hands-section/header';
import PercentagesOrCombos from '@/components/five-card-hands-section/percentages-or-combos';
import FiveCardHandsForCategory from '@/components/five-card-hands-section/five-card-hands-for-category';

export default {
  name: 'five-card-hands-section',
  components: {
    'five-card-hands-section-header': FiveCardHandsSectionHeader,
    'percentages-or-combos': PercentagesOrCombos,
    'five-card-hands-for-category': FiveCardHandsForCategory,
  },
  props: [
    'playerState',
    'hitPercentageUpToDate',
    'hideHeader',
    'showPercentagesOrCombos',
    'hideRightContainer',
    'shortDeck',
    'authorized',
  ],
  data: function () {
    return {
      percentagesOrCombos: 'percentages',
    };
  },
  computed: {
    insightsVisible: function () {
      return this.$store.state.account.user.settings.hitCalculator.insightsVisible;
    },
  },
  methods: {
    setCheckedValueOfFiveCardHand: function (payload) {
      this.$emit('setCheckedValueOfFiveCardHand', payload);
    },
  },
};
</script>

<style lang="scss" scoped>
  $icon-font-path: "~bootstrap-sass/assets/fonts/bootstrap/";
  $grid-gutter-width: 5px;
  @import "node_modules/bootstrap-sass/assets/stylesheets/bootstrap";

  .row {
    position: relative;
    right: 10px;
    margin-top: 17px;
  }

  .panel-body {
    padding-top: 5px;
  }

  .insights, .percentages-or-combos {
    margin-top: 10px;
  }

  @media (max-width: 767px) {
    .col-sm-4 {
      margin-bottom: 15px;
    }

    .col-sm-4:last-of-type {
      margin-bottom: 0;
    }
  }

  @media (max-width: 425px) {
    .col-sm-4 {
      padding-right: 0;
    }

    .col-sm-4 > span {
      font-size: 18px;
      font-weight: 500;
      padding-left: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/five-card-hands-section/five-card-hands-section.vue